/* AWA header (CLAUDE DRAFT) */
if (!customElements.get('awa-header')) {
  class AwaHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.topbar = this.querySelector('[data-awa-topbar]');
      this.bar = this.querySelector('.awa-header__bar');
      this.drawer = this.querySelector('#awa-drawer');
      this.toggle = this.querySelector('[data-awa-open]');
      this.count = this.querySelector('.awa-header__count');
      this.measure = this.measure.bind(this);
      this.measure();
      window.addEventListener('resize', this.measure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.measure);
      this.setupDrawer();
      this.setupMega();
      this.setupCascade();
      this.setupTabs();
      this.watchCount();
    }

    measure() {
      const topH = this.topbar ? this.topbar.offsetHeight : 0;
      if (this.classList.contains('awa-header--sticky') && this.section) {
        this.section.style.setProperty('--awa-sticky-top', `-${topH}px`);
      }
      const h = this.bar ? this.bar.offsetHeight : this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
      this.sizeMega && this.sizeMega();
    }

    setupDrawer() {
      if (!this.drawer || !this.toggle) return;
      const panel = this.drawer.querySelector('.awa-drawer__panel');
      const open = () => {
        this.drawer.hidden = false;
        requestAnimationFrame(() => this.drawer.classList.add('is-open'));
        this.toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        panel && panel.focus();
      };
      const close = () => {
        this.drawer.classList.remove('is-open');
        this.toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(() => { this.drawer.hidden = true; }, 250);
        this.toggle.focus();
      };
      this.toggle.addEventListener('click', open);
      this.drawer.querySelectorAll('[data-awa-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.drawer.hidden) close(); });
    }

    // Top menu items with a drop-down open and close on click only (no hover), JB Hi-Fi style.
    // While one is open the page behind is dimmed; clicking the dimmed page, another tab or pressing Esc closes it.
    // The drop-down runs from under the menu bar to the bottom of the screen; each column scrolls on its own.
    setupMega() {
      const items = [...this.querySelectorAll('.awa-nav__item--parent')];
      if (!items.length) return;
      const nav = this.querySelector('.awa-nav');
      let backdrop = document.querySelector('.awa-cx-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'awa-cx-backdrop';
        backdrop.hidden = true;
        document.body.appendChild(backdrop);
      }
      this.sizeMega = () => {
        if (!nav) return;
        const h = Math.max(320, window.innerHeight - nav.getBoundingClientRect().bottom);
        this.querySelectorAll('[data-awa-cx]').forEach((m) => m.style.setProperty('--awa-cx-h', `${h}px`));
      };
      const linkOf = (item) => item.querySelector(':scope > .awa-nav__link');
      const setOpen = (item, open) => {
        item.classList.toggle('is-open', open);
        item.classList.remove('is-closed');
        const link = linkOf(item);
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      const sync = () => { backdrop.hidden = !items.some((it) => it.classList.contains('is-open')); };
      const closeAll = (except) => { items.forEach((it) => { if (it !== except && it.classList.contains('is-open')) setOpen(it, false); }); sync(); };
      items.forEach((item) => {
        const link = linkOf(item);
        if (!link) return;
        link.setAttribute('aria-haspopup', 'true');
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const willOpen = !item.classList.contains('is-open');
          closeAll(item);
          if (willOpen) this.sizeMega();
          setOpen(item, willOpen);
          sync();
          if (!willOpen && e.detail > 0) link.blur();
        });
      });
      window.addEventListener('scroll', () => { if (items.some((it) => it.classList.contains('is-open'))) this.sizeMega(); }, { passive: true });
      backdrop.addEventListener('click', () => closeAll());
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const item = e.target.closest('.awa-nav__item--parent');
        closeAll();
        if (item) { const link = linkOf(item); link && link.focus(); }
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) closeAll(); });
    }

    // Inside an open drop-down: hovering or focusing a row shows the next column (orange highlight on the active row).
    // Rows with nothing under them (e.g. brands listed out from "More brands") hide the next column and go straight to their page.
    // On touch screens the first tap shows the next column; a second tap on the same row opens its page.
    setupCascade() {
      this.querySelectorAll('[data-awa-cx]').forEach((mega) => {
        const panel = mega.querySelector('.awa-cx__panel');
        const tabs = [...mega.querySelectorAll('[data-cx]')];
        const leaves = [...mega.querySelectorAll('[data-cx-leaf]')];
        const panes = [...mega.querySelectorAll('[data-cx-pane]')];
        const subs = [...mega.querySelectorAll('[data-cx3]')];
        const plains = [...mega.querySelectorAll('[data-cx-plain]')];
        const panes3 = [...mega.querySelectorAll('[data-cx3-pane]')];
        const show3 = (s) => {
          subs.forEach((x) => x.classList.toggle('is-active', x === s));
          panes3.forEach((p) => p.classList.toggle('is-active', !!s && p.dataset.cx3Pane === s.dataset.cx3));
          if (panel) panel.classList.toggle('has-3', !!s);
        };
        const show = (t) => {
          tabs.forEach((x) => x.classList.toggle('is-active', x === t));
          panes.forEach((p) => p.classList.toggle('is-active', !!t && p.dataset.cxPane === t.dataset.cx));
          if (panel) panel.classList.toggle('no-2', !t);
          show3(null);
        };
        if (!tabs.length && panel) panel.classList.add('no-2');
        tabs.forEach((t) => {
          t.addEventListener('mouseenter', () => { if (!t.classList.contains('is-active')) show(t); });
          t.addEventListener('focus', () => { if (!t.classList.contains('is-active')) show(t); });
          t.addEventListener('click', (e) => { if (!t.classList.contains('is-active')) { e.preventDefault(); show(t); } });
        });
        leaves.forEach((l) => {
          l.addEventListener('mouseenter', () => show(null));
          l.addEventListener('focus', () => show(null));
        });
        subs.forEach((s) => {
          s.addEventListener('mouseenter', () => show3(s));
          s.addEventListener('focus', () => show3(s));
          s.addEventListener('click', (e) => { if (!s.classList.contains('is-active')) { e.preventDefault(); show3(s); } });
        });
        plains.forEach((p) => {
          p.addEventListener('mouseenter', () => show3(null));
          p.addEventListener('focus', () => show3(null));
        });
      });
    }

    // Brand sidebar (older menu layout): hovering, focusing or clicking a brand shows its series.
    setupTabs() {
      this.querySelectorAll('.awa-mega--tabs').forEach((mega) => {
        const tabs = [...mega.querySelectorAll('[data-mega-tab]')];
        const panes = [...mega.querySelectorAll('[data-mega-pane]')];
        let timer;
        const show = (t) => {
          tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          panes.forEach((p) => { p.hidden = p.dataset.megaPane !== t.dataset.megaTab; });
        };
        tabs.forEach((t) => {
          t.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(() => show(t), 60); });
          t.addEventListener('mouseleave', () => clearTimeout(timer));
          t.addEventListener('focus', () => show(t));
          t.addEventListener('click', (e) => { e.preventDefault(); show(t); });
        });
      });
    }

    watchCount() {
      if (!this.count) return;
      const update = () => {
        const n = (this.count.textContent || '').trim();
        this.count.classList.toggle('is-empty', n === '' || n === '0');
      };
      update();
      new MutationObserver(update).observe(this.count, { childList: true, characterData: true, subtree: true });
    }
  }
  customElements.define('awa-header', AwaHeader);
}
